// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__7p4xb","options":"AnswerScale_options__1lBIp","selected":"AnswerScale_selected__16LAi"};